/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import { useOnClickOutside } from '../OutsideClick'

const PhoneNumberValidator = ({
    label,
    placeholder,
    id,
    htmlFor,
    value,
    emptyField,
    handleOnChangeInput,
    isCode,
    countryCodeList,
    index,
    country_code,
    countryCodeVal,
    setCountryCodeVal,
    submitSelected,
    handleCOuntryCodeForObj,
    isPhoneNumberValid,
    setIsPhoneNumberValid,
    data_testid,
    setIsOnType
}) => {

    const [phoneNumber, setPhoneNumber] = useState(value || '');
    const [isValid, setIsValid] = useState(true);
    const [isEntered, setIsEntered] = useState(false);
    const [isOpen, setisOpen] = useState(false)
    const ref = useRef();
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });



    const handlePhoneNumberChange = (event, isbtnclick, countryCode) => {

        setIsEntered(true)
        const newValue = isbtnclick !== undefined ? event : event.target.value;

        // Remove non-numeric characters from the input
        const numericValue = newValue.replace(/\D/g, '');

        setPhoneNumber(numericValue);
        index === undefined ? handleOnChangeInput(id, numericValue) : handleOnChangeInput(id, numericValue, index)

        try {
            // Extract numeric part from the country code
            const numericCountryCode = countryCode === undefined ? ((countryCodeVal === "" || countryCodeVal === undefined) ? country_code : countryCodeVal).replace(/\D/g, '') : countryCode;
            const fullPhoneNumber = `+${numericCountryCode}${numericValue}`;

            // Check if the fullPhoneNumber is empty and handle accordingly
            if (!fullPhoneNumber.trim()) {
                setIsValid(emptyField); // Empty field validation
            } else {

                // Pass numericCountryCode to parsePhoneNumber
                const phoneNumberObj = parsePhoneNumber(fullPhoneNumber, numericCountryCode);
                if (index === undefined) {
                    if (id === "mobile_number") {
                        setIsPhoneNumberValid((prev) => ({
                            ...prev,
                            mobile_number: phoneNumberObj?.isValid()

                        }))
                    }
                    else {
                        setIsPhoneNumberValid((prev) => ({
                            ...prev,
                            main_number: phoneNumberObj?.isValid()

                        }))
                    }

                } else {
                    setIsPhoneNumberValid(index, phoneNumberObj?.isValid(), id)

                }


                // Check if phoneNumberObj is defined before accessing its properties
                setIsValid(phoneNumberObj ? phoneNumberObj.isValid() : false);

            }
        } catch (error) {
            setIsValid(false);
        }
    };


    function handleCountryCOde(item) {
        setIsOnType !== undefined && setIsOnType(false)
        handlePhoneNumberChange(value, 'btnclick', item.split("-")[0].trim())
        if (index !== undefined) {
            handleCOuntryCodeForObj(index, item, id)
            setisOpen(false)

        } else {
            setCountryCodeVal(item.split("-")[0].trim())
            setisOpen(false)
        }

    }

    return (
        <div>
            <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] mb-1.5 more-lines'>{label}</label>
            <div className='relative'>
                <div className={`absolute top-[50%] -translate-y-[50%] left-1 ${isOpen ? "z-[999]" : "z-[0]"}`}>
                    {isCode && <div className='relative'>
                        <button onClick={() => setisOpen(!isOpen)} className='absolute top-[50%] -translate-y-[50%] left-4 text-base font-normal text-[#000000] flex items-center justify-between w-[64px] z-0'>
                            <p className='pr-0.5'>+{(countryCodeVal === "" || countryCodeVal === undefined) ? country_code : countryCodeVal}</p>
                            <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                        </button>
                        <ul ref={ref} className={`absolute top-[26px] z-50 left-0 p-2 rounded-lg border border-[#C5C9DA] w-[104px] bg-white h-fit ${isOpen ? "" : "hidden"}`}>
                            <li>
                                <ul className='max-h-[150px] bg-white overflow-auto pr-1 scrollbar_gray_thin' >

                                    {countryCodeList?.map((item, index) => (
                                        <li key={index}>
                                            <p onClick={() => { handleCountryCOde(item) }} className={`text-sm font-normal cursor-pointer  ${item === countryCodeVal ? `text-base text-[#008586]` : 'text-sm font-normal text-[#000]'} hover:text-[#008586] mb-2`}>{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul>
                    </div>
                    }
                </div>
                <input
                    type='text'
                    id={id}
                    data-testid={data_testid}
                    value={value}
                    onChange={(e) => { setIsOnType !== undefined && setIsOnType(true), handlePhoneNumberChange(e) }}
                    placeholder={placeholder}
                    className={`border ${emptyField || (submitSelected && !isValid && value != "") ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg pr-3.5 pl-[90px] py-[11px] text-base font-normal text-[#000B17] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-sm outline-none appearance-none`}
                />
            </div>
            {value?.length > 0 && <>
                {isPhoneNumberValid ? (
                    <p style={{ color: 'green' }} className='text-sm font-normal mt-2'>Valid {label.endsWith('*') ? label.slice(0, -1) : label}</p>
                ) : (
                    <p className='text-sm font-normal text-[#F04438] mt-2'>Invalid {label.endsWith('*') ? label.slice(0, -1) : label}</p>
                )
                }

            </>
            }

        </div>
    );
};

export default PhoneNumberValidator;
